import React, { memo } from 'react';
import { Row, Col, Space, Button } from 'antd';
import { FormattedMessage } from 'react-intl';
import { DownloadOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { User } from 'utils/apiClient/services/contacts/types';
import { ReportType } from 'utils/apiClient/services/reports/types';
import EmployeesFilter from './EmployeesFilter';
import TipReportTypeSelect from './TipReportTypeSelect';

type Props = {
  reportType: 'summary' | 'list';
  rangeReportType?: ReportType;
  users: Array<User> | undefined;
  handleReportTypeChange?: (type: ReportType) => void;
  handleDownload?: () => void;
  downloadInProgress?: boolean;
  isLoading?: boolean;
  isDisabled?: boolean;
  handleUsersFilterChange: (values: number[]) => void;
};

const DownloadIcon = styled(DownloadOutlined)`
  font-size: 18px;
`;

const SelectWrapper = styled.div`
  right: 30px;
  top: 10px;
`;
const DownloadButton = styled(Button)`
  border: none;
  background: none !important;
  box-shadow: none !important;
  border-color: transparent !important;
  border-style: none;
  --antd-wave-shadow-color: transparent !important;
`;

const TipReportHeader: React.FC<Props> = ({
  reportType,
  rangeReportType,
  users,
  downloadInProgress,
  isDisabled,
  handleDownload,
  handleReportTypeChange,
  handleUsersFilterChange,
}) => (
  <Row css="padding: 0.5em 0">
    <Col span={4}>
      <h3 css="margin: 0; line-height: 2em;padding-left: 8px">
        {reportType === 'summary' ? (
          <FormattedMessage defaultMessage="Summary" />
        ) : (
          <FormattedMessage defaultMessage="Tip per transaction" />
        )}
      </h3>
    </Col>
    <Col span={20} css=" display: flex; justify-content: flex-end;">
      <Space size="middle">
        {reportType === 'summary' && rangeReportType && handleReportTypeChange && (
          <SelectWrapper>
            <TipReportTypeSelect
              value={rangeReportType}
              handleChange={handleReportTypeChange}
            />
          </SelectWrapper>
        )}
        <EmployeesFilter
          handleUsersFilterChange={handleUsersFilterChange}
          employees={users}
        />
        <DownloadButton
          icon={<DownloadIcon />}
          onClick={handleDownload}
          loading={downloadInProgress}
          disabled={isDisabled}
          data-testid="download"
        />
      </Space>
    </Col>
  </Row>
);

export default memo(TipReportHeader);
